import React, { Component } from 'react';
import { truncateTitle } from '../../../helpers/textHelpers';
import {
  ShareModalWrapper,
  ShareLinkWrapper,
  ShareLink,
  CopyButton,
  Notify,
} from './style';
import Text from 'reusecore/src/elements/Text';

import SocialShare from '../../../components/SocialShare';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { withTranslation } from 'next-i18next';

class ShareModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCopied: false,
      text:
        props.data.link.indexOf('?s') > 0
          ? props.data.link
          : props.data.link + '?s',
    };
  }

  render() {
    const {
      data: { image, price, title },
      t,
    } = this.props;

    return (
      <ShareModalWrapper>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {image && (
            <div>
              <img
                src={image}
                alt={title}
                style={{
                  marginRight: '10px',
                  width: '150px',
                  height: '120px',
                  objectFit: 'cover',
                }}
              />
            </div>
          )}
          <div>
            <div>
              <Text
                type="heading"
                as="h3"
                fontSize={24}
                fontWeight={600}
                color="#333333"
                mb="5px"
                content={truncateTitle(title)}
              />
              {price > 0 && (
                <Text
                  content={`${price} ${process.env.CURRENCY}`}
                  type="normal"
                  size="medium"
                  color="#00BCD4"
                  mb={18}
                  style={{
                    fontWeight: '400',
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <ShareLinkWrapper>
          <ShareLink
            type="text"
            value={this.state.text}
            onChange={e => {
              this.setState({ text: e.target.value, isCopied: false });
            }}
          />

          <CopyToClipboard
            onCopy={() => {
              this.setState({ isCopied: true });
            }}
            text={this.state.text}
          >
            <CopyButton>
              {this.state.isCopied ? (
                <Notify>{t('adsView.view.share.success')}</Notify>
              ) : null}
              {t('adsView.view.share.button')}
            </CopyButton>
          </CopyToClipboard>
        </ShareLinkWrapper>

        <SocialShare url={this.state.text} title={title} />
      </ShareModalWrapper>
    );
  }
}

export default withTranslation()(ShareModal);
